<template>
  <div id="order-streamer">
    <!-- 预约成功 -->
    <div  v-if="typeVal===1">
      <MyLine/>
      <div class="streamer">
        <p class="p1">预约成功</p>
        <p class="p2">服务专员即将上门为您办理年审服务</p>
        <div class="p3">
          <p>请提前准备以下材料正本:</p>
          <p>身份证、驾驶证、行驶证、交强险保单</p>
        </div>
      </div>
      <MyLine/>
    </div>
    <!-- 正在办理 -->
    <div  v-if="typeVal===2">
      <MyLine/>
      <div class="streamer">
        <p class="p1">正在办理</p>
        <p class="p2">服务专员正在为您办理年审服务</p>
      </div>
      <MyLine/>
    </div>
    <!-- 线上缴费 -->
    <div  v-if="typeVal===3">
      <MyLine/>
      <div class="streamer">
        <p class="p1">线上缴费</p>
        <p class="p2">已为您办理完结年审服务,请确认付款</p>
      </div>
      <MyLine/>
    </div>
    <!-- 已完结 -->
    <div  v-if="typeVal===4">
      <MyLine/>
      <div class="streamer">
        <p class="p1">已完结</p>
        <p class="p2">已缴纳年审费用￥300</p>
      </div>
      <MyLine/>
    </div>
    <!-- 取消预约 -->
    <div  v-if="typeVal===5">
      <div class="streamer">
        <p class="p1">取消预约</p>
        <p class="p2">已为您取消预约年审服务</p>
      </div>
      <MyLine/>
    </div>
  </div>
</template>

<script>
  import MyLine from '../widget/line'

  export default {
    name: "orderStreamer",
    props:{
      type:{type: Number},
    },
    components:{
      MyLine,
    },
    data() {
      return {
        typeVal:this.type, // 横幅类型(1:预约成功, 2:正在办理, 3:线上缴费, 4:已完结, 5:取消预约)
      }
    },
    watch:{
      type() {
        this.typeVal = this.type
      }
    }
  }
</script>

<style scoped>
  #order-streamer{
    background: white;
  }
  .streamer{
    padding: 7.6vw;
  }
  .p1{
    font-size: 5.867vw;
    color: #303133;
    font-weight: bold;
  }
  .p2{
    font-size: 4vw;
    color: #909399;
    margin-top: 2.4vw;
  }
  .p3{
    font-size: 3.467vw;
    color: #303133;
    margin-top: 4.733vw;
  }
</style>
